import { RootState } from '@redux/store';

export const selectFeaturedListActiveTabKey = (state: RootState) => state.mainDashboard.featuredListActiveTabKey;
export const selectActiveDashboardPanelKey = (state: RootState) => state.mainDashboard.activePanelKey;
export const selectIsEditDrawerOpen = (state: RootState) => state.mainDashboard.isEditDrawerOpen;
export const selectCurrentAppName = (state: RootState) => state.mainDashboard.currentAppName;

export const selectFeaturedListSize = (state: RootState) => state.mainDashboard.panelSizeState.FeaturedList;
